@file:OptIn(InternalResourceApi::class)

package demo.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/demo.composeapp.generated.resources/"

@delegate:ResourceContentHash(470_159_096)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-421_724_413)
internal val Res.drawable.launcher: DrawableResource by lazy {
      DrawableResource("drawable:launcher", setOf(
        ResourceItem(setOf(), "${MD}drawable/launcher.svg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_526_778_789)
internal val Res.drawable.marker: DrawableResource by lazy {
      DrawableResource("drawable:marker", setOf(
        ResourceItem(setOf(), "${MD}drawable/marker.svg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("launcher", Res.drawable.launcher)
  map.put("marker", Res.drawable.marker)
}
